// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"c6497adc","416":"b4b5679a","529":"7e8df53b","693":"85c4536d","971":"0b61a7d6"}[chunkId] + ".chunk.js";
};